var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.63a9.37 9.37 0 00-1.464 18.628v-6.549h-2.38V12h2.38V9.936c0-2.35 1.4-3.647 3.539-3.647 1.025 0 2.099.183 2.099.183v2.304h-1.185c-1.162 0-1.525.724-1.525 1.465v1.757h2.596l-.415 2.71h-2.181v6.548A9.37 9.37 0 0012 2.63z",
    fill: "#002C48"
  })));
}
export default SvgFacebook;